import React from 'react';
import { BillStatus, QueueStatus, SourceBadge } from '../common/Badges';
import { fmtTime } from '../../utils/dates';

function maskPhone(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (digits.length < 10) return phone || '';
  const local = digits.slice(-10);
  return `+91 ${local.slice(0, 5)} ${local.slice(5)}`;
}

export default function QueueCard({ entry, onStart, busy }) {
  const billed = Boolean(entry.bill);
  return (
    <article className={`dp-queue-card${billed ? ' is-billed' : ''}`}>
      <div className="dp-queue-time">
        <strong>{fmtTime(entry.time)}</strong>
        <QueueStatus status={entry.status} label={entry.status_label} />
      </div>
      <div className="dp-queue-main">
        <div className="dp-queue-who">
          <h4>{entry.customer_name || 'Guest'}</h4>
          <span>{maskPhone(entry.phone)}</span>
          {entry.customer_code ? <span className="dp-code">#{entry.customer_code}</span> : null}
        </div>
        <div className="dp-queue-services">
          {(entry.services || []).length ? (
            entry.services.map((s, i) => (
              <span key={`${s.name}-${i}`} className="dp-chip">
                {s.name}
                {s.staff_name ? <em>· {s.staff_name}</em> : null}
              </span>
            ))
          ) : (
            <span className="dp-muted">No service picked yet</span>
          )}
        </div>
        <SourceBadge entry={entry} />
      </div>
      <div className="dp-queue-action">
        {billed ? <BillStatus status={entry.bill.status} /> : null}
        <button
          type="button"
          className={`dp-btn${billed ? ' dp-btn--ghost' : ''}`}
          onClick={() => onStart(entry)}
          disabled={busy}
        >
          {billed ? 'Open bill' : 'Create bill'}
        </button>
      </div>
    </article>
  );
}
